// PURPOSE: Render an individual dog search result as a table row
//          Called by DogFeed.js
// Column order: id, acct_id, last_name, first_name, m_initial,
//   email, phone, number_addr1, street_addr1, addr2, city_name,
//   state_code, zip, cnty_district, paperless

const DogList = ({ customer, onSelect }) => {
	let id = customer[0]
	let acct = customer[1]
	let name =
		customer[3] === "" || customer[3] === null
			? customer[2]
			: customer[2] + ", " + customer[3]
	let phone = customer[6]
	let addr =
		(customer[7] ?? "") +
		" " +
		(customer[8] ?? "") +
		" " +
		(customer[10] ?? "") +
		" " +
		(customer[11] ?? "") +
		" " +
		(customer[12] ?? "")
	let district = customer[13]

	return (
		<tr className="dogRow">
			<td hidden>{id}</td>
			<td>{acct}</td>
			<td>{name}</td>
			<td>{phone}</td>
			<td>{addr}</td>
			<td>{district}</td>
			<td>
				<button
					className="tblBtn"
					type="button"
					onClick={() => onSelect(customer)}
				>
					Select
				</button>
			</td>
		</tr>
	)
}

export default DogList
